const CHAIN_SWITCHED = '/chain-switched';
const WIPE_SEED = '/wipe-seed';
const UNLOCK = '/unlock';
const ORDER_BOOK = '/app/orderbook';
const TRADED_PAIRS = '/app/traded-pairs';
const ONBOARDING = '/app/onboarding';
const ONBOARDING_CREATE = '/app/onboarding/create';
const ONBOARDING_IMPORT = '/app/onboarding/import';
const SETTINGS = '/app/settings';
const SETTINGS_ACCOUNT = '/app/settings/account';
const SETTINGS_CONNECTIVITY = '/app/settings/connectivity';
const SETTINGS_STORAGE = '/app/settings/storage';
const MY_ORDERS = '/app/operations';
const WALLET = '/app/wallet';
const WALLET_BALANCES = '/app/wallet/balances';
const WALLET_DEPOSIT = '/app/wallet/deposit';
const WALLET_WITHDRAW = '/app/wallet/withdraw';

const DEFAULT = TRADED_PAIRS;

const PATHS = {
  DEFAULT,
  WIPE_SEED,
  CHAIN_SWITCHED,
  UNLOCK,
  ORDER_BOOK,
  TRADED_PAIRS,
  ONBOARDING,
  ONBOARDING_CREATE,
  ONBOARDING_IMPORT,
  SETTINGS,
  SETTINGS_ACCOUNT,
  SETTINGS_CONNECTIVITY,
  SETTINGS_STORAGE,
  MY_ORDERS,
  WALLET,
  WALLET_BALANCES,
  WALLET_DEPOSIT,
  WALLET_WITHDRAW,
};

export default PATHS;
